<!-- nav -->
<a class="skip-link" id="skiptocontent" [href]="skipLinkPath"
  >Skip to content</a
>
<nav
  class="navbar navbar-expand-lg navbar-light bg-white border-top px-lg-0 py-0"
  id="main-menu"
>
  <a
    class="navbar-brand font-small"
    id="top_link"
    [ngClass]="cssColor"
    [routerLink]="[firstPageUrl]"
  >
    <img
      src="{{ logoImage }}"
      width="48"
      height="48"
      class="d-inline-block"
      alt="{{ courseName }}"
    />
    <span class="text-uppercase" id="team">{{ courseName }}</span>
  </a>
  <button
    class="navbar-toggler"
    type="button"
    data-toggle="collapse"
    data-target="#navbarSupportedContent"
    aria-controls="navbarSupportedContent"
    aria-expanded="false"
    aria-label="Toggle navigation"
  >
    <span class="navbar-toggler-icon"></span>
  </button>
  <div class="navbar-collapse collapse w-100" id="navbarSupportedContent">
    <ul
      class="nav navbar-nav ml-auto w-100 justify-content-end"
      role="tablist"
      aria-label="main navigation"
      style="line-height: 1.5"
    >
      <ng-container *ngFor="let itm of menu?.items">
        <li
          class="nav-link-outline nav-item"
          [class.active]="isSelected(itm.path)"
          *ngIf="itm.items?.length <= 0"
          [ngClass]="[itm.withSeparator ? 'separator' : '']"
        >
          <a
            class="nav-link"
            routerLink="{{ itm.path }}"
            [attr.aria-selected]="isSelected(itm.path)"
            role="tab"
            >{{ itm.caption }}</a
          >
        </li>

        <li
          class="nav-item"
          ngbDropdown
          #myDrop="ngbDropdown"
          [class.active]="isSelected(itm.path)"
          [attr.aria-selected]="isSelected(itm.path)"
          role="tab"
          *ngIf="hasChildren(itm)"
          [ngClass]="[itm.withSeparator ? 'separator' : '']"
        >
          <button
            class="nav-link-outline dropdown-toggle"
            id="navbarDropdown"
            ngbDropdownToggle
            aria-haspopup="true"
          >
            {{ itm.caption }}
          </button>
          <div
            class="dropdown-menu shadow"
            aria-labelledby="navbarDropdown"
            ngbDropdownMenu
          >
            <div class="arrow-up"></div>

            <ng-container *ngFor="let subitm of itm?.items">
              <a
                class="dropdown-item dropdown-sub nav-active"
                *ngIf="!subitm.noEncode"
                [routerLink]="['/' + subitm.path]"
                [queryParams]="{ region: subitm.regionId }"
                [hidden]="subitm.notAccessibleInDemo && isDemo"
                href="javascript:void(0);"
                >{{ subitm.caption }}
              </a>
              <a
                class="dropdown-item dropdown-sub nav-active"
                *ngIf="!subitm.noEncode"
                [hidden]="!subitm.notAccessibleInDemo || !isDemo"
                (click)="openNotAccessible()"
                style="cursor: pointer; color: #454d56 !important"
                href="javascript:void(0);"
                ><img src="img/lock.png" />{{ subitm.caption }}
              </a>

              <a
                class="dropdown-item dropdown-sub nav-active"
                *ngIf="subitm.noEncode"
                href="{{ subitm.path }}"
                [hidden]="subitm.notAccessibleInDemo && isDemo"
                href="javascript:void(0);"
                >{{ subitm.caption }}</a
              >
              <a
                class="dropdown-item dropdown-sub nav-active"
                *ngIf="subitm.noEncode"
                [hidden]="!subitm.notAccessibleInDemo || !isDemo"
                (click)="openNotAccessible()"
                style="cursor: pointer; color: #454d56 !important"
                href="javascript:void(0);"
                ><img src="img/lock.png" />{{ subitm.caption }}</a
              >
            </ng-container>
          </div>
        </li>

        <li
          class="nav-item"
          ngbDropdown
          #myDrop2="ngbDropdown"
          [class.active]="isSelected(itm.path)"
          [attr.aria-selected]="isSelected(itm.path)"
          role="tab"
          *ngIf="hasChildren2(itm)"
          [ngClass]="[itm.withSeparator ? 'separator' : '']"
        >
          <button
            class="nav-link-outline dropdown-toggle"
            id="navbarDropdown"
            ngbDropdownToggle
            aria-haspopup="true"
          >
            {{ itm.caption }}
          </button>
          <div
            class="dropdown-menu shadow"
            aria-labelledby="navbarDropdown"
            ngbDropdownMenu
          >
            <div class="arrow-up"></div>
            <ng-container *ngFor="let itm of itm?.items">
              <a
                class="dropdown-item nav-active"
                [ngClass]="cssColor"
                id="dropdown-region1"
                href="javascript:void(0);"
                *ngIf="!itm.items"
                [routerLink]="['/' + itm.path]"
                [hidden]="itm.notAccessibleInDemo && isDemo"
                >{{ itm.caption }}</a
              >
              <a
                class="dropdown-item nav-active"
                [ngClass]="cssColor"
                id="dropdown-region1"
                href="javascript:void(0);"
                *ngIf="!itm.items"
                [hidden]="!itm.notAccessibleInDemo || !isDemo"
                (click)="openNotAccessible()"
                style="cursor: pointer; color: #454d56 !important"
                ><img src="img/lock.png" />{{ itm.caption }}</a
              >

              <span
                class="dropdown-item nav-active"
                [ngClass]="cssColor"
                id="dropdown-region1"
                *ngIf="itm.items"
                href="javascript:void(0);"
                >{{ itm.caption }}</span
              >
              <div class="dropdown-divider" *ngIf="itm.items"></div>
              <span class="dropdown-sub-1" *ngIf="itm.items">
                <ng-container *ngFor="let subitm of itm?.items">
                  <a
                    class="dropdown-item dropdown-sub"
                    [routerLink]="['/' + subitm.path]"
                    [hidden]="subitm.notAccessibleInDemo && isDemo"
                    href="javascript:void(0);"
                    [queryParams]="{ region: subitm.regionId }"
                    >{{ subitm.caption }}</a
                  >
                  <a
                    class="dropdown-item dropdown-sub"
                    [hidden]="!subitm.notAccessibleInDemo || !isDemo"
                    (click)="openNotAccessible()"
                    href="javascript:void(0);"
                    style="cursor: pointer; color: #454d56 !important"
                    ><img src="img/lock.png" />{{ subitm.caption }}</a
                  >
                </ng-container>
                <div class="dropdown-divider"></div>
              </span>
            </ng-container>
          </div>
        </li>
      </ng-container>
      <li
        class="my-auto separator"
        id="time"
        *ngIf="displayTimer && !noRankingMode && !isDemo"
      >
        <button
          type="button"
          class="btn"
          id="btn-time"
          [disabled]="!timeExceeded"
          tabindex="-1"
        >
          <img src="img/clock.svg" />{{ timeLeft }}
        </button>
      </li>
      <!--         <li id="login" class="separator">
                <img src="img/team.svg">
              </li>-->
      <li class="nav-item" ngbDropdown #myDrop="ngbDropdown" class="separator">
        <button
          class="nav-link-outline"
          id="navbarDropdown-hamburger"
          role="tab"
          ngbDropdownToggle
          aria-haspopup="true"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div
          class="dropdown-menu-right shadow"
          aria-labelledby="navbarDropdown"
          ngbDropdownMenu
        >
          <a
            class="dropdown-item dropdown-sub"
            href="#"
            [routerLink]="[documentUrl]"
            >{{ documentsText }}</a
          >
          <a
            class="dropdown-item dropdown-sub"
            *ngIf="onboardingUrl"
            href="#"
            [routerLink]="[onboardingUrl]"
            >{{ onboardingText }}</a
          >
          <a
            class="dropdown-item dropdown-sub"
            href="javascript:void(0);"
            *ngIf="supportedLanguages?.length > 1"
            (click)="openLanguageSelector()"
            >{{ languagesText }}</a
          >
          <a
            class="dropdown-item dropdown-sub"
            href="#"
            *ngIf="displayTeam"
            [routerLink]="[teamUrl]"
            >{{ teamText }}</a
          >

          <a
            class="dropdown-item dropdown-sub"
            href="javascript:void(0);"
            *ngIf="enableHighContrasts && !highContrast"
            (click)="setHighContrast()"
            >{{ enableHighContrastsText }}</a
          >
          <a
            class="dropdown-item dropdown-sub"
            href="javascript:void(0);"
            *ngIf="enableHighContrasts && highContrast"
            (click)="unsetHighContrast()"
            >{{ disableHighContrastsText }}</a
          >
          <a
            class="dropdown-item dropdown-sub"
            href="javascript:void(0);"
            *ngIf="enableScreenReaderMode && !screenReaderFriendly"
            (click)="setScreenReaderFriendly()"
            >{{ enableScreenReaderText }}</a
          >
          <a
            class="dropdown-item dropdown-sub"
            href="javascript:void(0);"
            *ngIf="enableScreenReaderMode && screenReaderFriendly"
            (click)="unScreenReaderFriendly()"
            >{{ disableScreenReaderText }}</a
          >

          <div class="dropdown-divider"></div>
          <a
            class="dropdown-item dropdown-sub"
            (click)="logout()"
            href="javascript:void(0);"
            *ngIf="displayLogOut"
            >{{ logoutText }}</a
          >
        </div>
      </li>
    </ul>
  </div>
</nav>

<app-notaccessibledialog
  #dialog
  [texts]="blockedByDemoTexts"
></app-notaccessibledialog>
<app-languageselectiondialog
  #languageSelectionDialog
></app-languageselectiondialog>
